
// src/mockData.js
// Static data used by the fake API (dashboardApi.js).
// Replace these with your own sample data or remove entirely
// when you plug in a real backend.

export const mockCurrentOrders = [
  { id: 1, name: 'Snacks', price: 99.0, quantity: 1 },
  { id: 2, name: 'Snacks', price: 99.0, quantity: 1 },
  { id: 3, name: 'Snacks', price: 99.0, quantity: 1 }
];

export const mockActivities = {
  months: ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'],
  values: [80, 100, 90, 75, 110, 95, 105, 90, 85, 100, 95, 110]
};

export const mockSummary = {
  title: 'Customers',
  value: 19017,
  increasedPercent: 15,
  bars: [30, 60, 45, 90, 70]
};

export const mockCalendar = {
  monthLabel: 'January 2022',
  activeDay: 21,
  daysOfWeek: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],
  dates: [
    ['','', '', '', '', '', 1],
    [2,3,4,5,6,7,8],
    [9,10,11,12,13,14,15],
    [16,17,18,19,20,21,22],
    [23,24,25,26,27,28,29],
    [30,31,'','','','','']
  ]
};

export const mockRevenue = {
  totalLabel: '₹24,050,00.00',
  rows: [
    { label: 'Food' },
    { label: 'Beverage' },
    { label: 'Snack' }
  ],
  heatmap: [
    [4,3,2,1,2,3,4],
    [2,1,2,3,4,3,2],
    [1,2,3,4,3,2,1]
  ],
  days: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],
  legends: [
    { label: '₹15000.00', color: 'legend-1' },
    { label: '₹7000.00', color: 'legend-2' },
    { label: '₹3564.00', color: 'legend-3' }
  ]
};

export const mockReceipt = {
  items: [
    { label: 'Items', amount: 2000 },
    { label: 'Items', amount: 2000 },
    { label: 'Items', amount: 2000 },
    { label: 'Items', amount: 2000 }
  ],
  subtotal: 512.0,
  tax: 18.2,
  discount: 5.3,
  total: 535.8
};

export const mockManagement = {
  filter: 'Weekly',
  orders: Array.from({ length: 7 }).map((_, idx) => ({
    id: `#12324${idx}`,
    date: 'Jun 24, 2025',
    customer: 'Andi Lane',
    price: '$953.00',
    paymentStatus: idx % 2 === 0 ? 'Paid' : 'Unpaid',
    items: `${idx + 1} Items`,
    status: idx % 3 === 0 ? 'Complete' : 'Processing'
  }))
};

export const mockCashier = {
  totalOrders: 87,
  main: {
    name: 'Ramadhan',
    status: 'Working'
  },
  othersCount: 26
};

export const mockCashierStats = {
  totalOrders: 87,
  bubbles: [
    { id: 'sales', size: 'lg', value: '50%' },
    { id: 'category1', size: 'md', value: '30%' },
    { id: 'purchase', size: 'sm', value: '20%' }
  ],
  labels: ['Sales', 'Purchase', 'Category1']
};
